<template>
    <div class="form-field form-html" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">


                <editor v-model="internalValue" api-key="8de12z8u7irytsdoc9uyvnq5ps1br89eq4keb1nig145bue9" :init="configEditor"></editor>

                <!--<froala :tag="'textarea'" :config="config" v-model="internalValue"></froala>-->
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
            </div>
        </div>
    </div>
</template>

<script>

    import Editor from '@tinymce/tinymce-vue';

    export default {
        name: 'FormFieldHtml',
        props: ['value','label','name','placeholder','lang','tag','config','required'],
        components: {
            'editor': Editor
        },
        data: function () {
            return {
                internalValue: '',
                langClass: '',
                configEditor: {
                    plugins: "code,table",
                    branding: false,
                    menubar:false,
                    statusbar: false,
                    toolbar: 'bold italic | fontsizeselect forecolor backcolor | link image media table | alignleft aligncenter alignright alignjustify | numlist bullist | code'
                }
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && this.required == 'true' ? true : false
            //this.configEditor = this.configEditor;
            //this.configEditor = this.config ? this.config : this.configEditor;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Html.vue